import type { Line2, Mesh, MeshBasicMaterial, Object3D, Vector3 } from '@anov/3d-core'
import { Color } from '@anov/3d-core'

import _ from 'lodash'
import ObjectLayer from '../../Base/ObjectLayer'
import type { FillAreaOption } from '../type'
import { Area } from '..'

class FillAreaBase extends ObjectLayer {
  public _mesh!: Mesh | Line2
  public _alpha: number
  public _color: string
  public _corner: number
  public _close: boolean
  public _points!: Vector3[]
  public _uri: string
  public _option: FillAreaOption
  public _listeners = new Set()

  private _areaInstance: Object3D

  constructor(option: FillAreaOption, areaInstance: any) {
    super(areaInstance.sceneControl)
    this._option = option
    // 属性赋值
    this._initParams(option)
    this._areaInstance = areaInstance
    // 属性赋值
    // this.setValues(_.mergeWith({}, defaultOption, option))
  }

  public get mesh() {
    return this._mesh
  }

  public get uri() {
    return this._uri
  }

  public set uri(value: string) {
    if (this._uri === value)
      return
    this._uri = value
    // eslint-disable-next-line max-statements-per-line
    this._listeners.forEach((cb: Function) => { cb.call(this._areaInstance) })
  }

  // Getter and Setter for alpha property
  get alpha(): number {
    return this._alpha
  }

  set alpha(newValue: number) {
    if (this._alpha === newValue)
      return

    this._alpha = newValue
    if (this._mesh)
      (this._mesh.material as MeshBasicMaterial).opacity = newValue
  }

  // Getter and Setter for color property
  get color(): string {
    return this._color
  }

  set color(newValue: string) {
    if (this._color === newValue)
      return

    this._color = newValue
    if (this._mesh)
      (this._mesh.material as MeshBasicMaterial).color = new Color(newValue)
  }

  get corner(): number {
    return this._corner
  }

  set corner(newValue: number) {
    if (this._corner === newValue)
      return

    this._corner = newValue
  }

  get close(): boolean {
    return this._close
  }

  set close(newValue: boolean) {
    if (this._close === newValue)
      return

    this._close = newValue
  }

  _initParams(option: FillAreaOption) {
    this._alpha = option.alpha
    this._color = option.color
    this._close = option.close
    this._corner = option.corner
    this._points = option.points as unknown as Vector3[]
    this._uri = option.uri
  }

  public delete() {
    this._mesh.remove()
    this._mesh.removeFromParent()
  }

  // 销毁
  public dispose() {
    this.delete()
    this._listeners.clear()
  }

  // 注册监听
  public addReloadListener(callback: Function) {
    this._listeners.add(callback)
  }
}

export default FillAreaBase